import { render, staticRenderFns } from "./CardMessage.vue?vue&type=template&id=cb570ca0"
import script from "./CardMessage.vue?vue&type=script&lang=js"
export * from "./CardMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports